import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { RouterModule } from '@angular/router';

import { AdminRoutingModule } from './admin-routing.module';
import { AdminLayoutComponent } from './shared/admin-layout/admin-layout.component';
import { AdminDashboardPageComponent } from './shared/admin-dashboard-page/admin-dashboard-page.component';
import { MaterialModule } from '../material/material.module';


@NgModule({
  declarations: [
    AdminLayoutComponent,
    AdminDashboardPageComponent
  ],
  imports: [
    CommonModule,
    OverlayModule,
    RouterModule,
    MaterialModule,
    AdminRoutingModule,
  ]
})
export class AdminModule { }
